import type { FC } from 'react'

import { Select } from '@skytech/ui'
import { uniq } from '@skytech/utils/list-operations'
import { useQuery } from '@tanstack/react-query'
import type { FieldProps } from 'formik'
import { Field } from 'formik'

import { Translation } from '@/app/translations/Translation'

import { Accounting } from './Accounting'

import queries from '../../queries'
import adminQueries from '../../queries'
import adminResources from '../../resources'

export const ConnectedEntities: FC<{ selectedCustomerId: number }> = ({ selectedCustomerId }) => {
  const { data: addresses } = useQuery(queries.adminAddresses(), adminResources.getAddressList)
  const { data: customers } = useQuery(queries.adminCustomers(), adminResources.getCustomers)
  const customerName = customers?.find(customer => customer.id === selectedCustomerId)?.name
  const addressOptions = addresses
    ?.filter(address => address.isGlobal || address.customerName === customerName)
    .map(address => ({
      value: address.id,
      label: `${address.address}, ${address.zip} ${address.city}`,
    }))

  const { data: departmentList } = useQuery(
    adminQueries.adminDepartmentsList(),
    adminResources.getDepartmentsList
  )

  const departmentOptions =
    departmentList
      ?.filter(department => department.customer.id === selectedCustomerId && !department.inactive)
      ?.map(department => ({
        value: department.id,
        label: [department.code, department.name].join(' - '),
      })) || []

  return (
    <div className="wrap flex">
      <div className="mx-2 flex flex-1 basis-[30rem] flex-col rounded-lg">
        <Field name="customerAddressId">
          {({ field, form }: FieldProps) => (
            <Select
              capitalizeLabel
              id="customerAddressId"
              label={
                <>
                  <Translation id="Address" />*
                </>
              }
              options={uniq(addressOptions)}
              marginBottom={16}
              {...field}
              onChange={option => form.setFieldValue(field.name, option?.value)}
            />
          )}
        </Field>
        <Field name="departmentId">
          {({ field, form }: FieldProps) => (
            <Select
              capitalizeLabel
              id="departmentId"
              label={
                <>
                  <Translation id="Department" />*
                </>
              }
              options={departmentOptions}
              marginBottom={16}
              {...field}
              onChange={option => form.setFieldValue(field.name, option?.value)}
            />
          )}
        </Field>
      </div>

      <div className="mx-2 flex flex-1 basis-[30rem] flex-col rounded-lg">
        <Accounting />
      </div>
    </div>
  )
}
